module.exports = __webpack_public_path__ + "media/images/category/dummy/bottoms05-32f4ad8b44f1132dd49e7c5a892a7853.jpg";